import { render, staticRenderFns } from "./RSQViolenceForm5.vue?vue&type=template&id=376c6771&"
import script from "./RSQViolenceForm5.vue?vue&type=script&lang=js&"
export * from "./RSQViolenceForm5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports